var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Tag from "./Tag";
var PixelData = /** @class */ (function () {
    function PixelData() {
    }
    Object.defineProperty(PixelData, "getAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (dataset) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, PixelData._getixelDataViews(dataset)];
                });
            });
        }
    });
    Object.defineProperty(PixelData, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (dataset_1) {
            return __awaiter(this, arguments, void 0, function (dataset, frame) {
                var pixelDatas;
                if (frame === void 0) { frame = 0; }
                return __generator(this, function (_a) {
                    pixelDatas = PixelData._getixelDataViews(dataset);
                    if (frame > pixelDatas.length) {
                        throw new Error("Frame ".concat(frame, " not found."));
                    }
                    return [2 /*return*/, pixelDatas[frame]];
                });
            });
        }
    });
    Object.defineProperty(PixelData, "_getixelDataViews", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (dataset) {
            var pixelData = dataset.tags['0x7FE00010'] || dataset.tags['0x7FE00008'] || dataset.tags['0x7FE00009'];
            var pixelDatas = [];
            var numberOfFrames = dataset.pixelModule.numberOfFrames || 1;
            if (pixelData.valueLength === 0xFFFFFFFF) {
                var offset = pixelData.offset;
                while (true) {
                    if (offset >= dataset.dataView.byteLength) {
                        break;
                    }
                    var group = dataset.dataView.getUint16(offset, dataset.littleEndian);
                    offset += 2;
                    var element = dataset.dataView.getUint16(offset, dataset.littleEndian);
                    offset += 2;
                    if (group !== 0xFFFE && element !== 0xE000) {
                        break;
                    }
                    else {
                    }
                    console.log('group', Tag.intTo4digitString(group));
                    console.log('element', Tag.intTo4digitString(element));
                    var len = dataset.dataView.getUint32(offset, dataset.littleEndian);
                    offset += 4;
                    if (len !== 0) {
                        console.log('element is 2', len);
                        if (len > 4) {
                            var dataView = new DataView(dataset.dataView.buffer.slice(offset, offset + len));
                            pixelDatas.push(dataView);
                        }
                        else {
                            offset - 4;
                        }
                        offset += len;
                    }
                }
            }
            else {
                var frameLen = pixelData.valueLength / numberOfFrames;
                for (var i = 0; i < numberOfFrames; i++) {
                    var offset = pixelData.offset + (frameLen * i);
                    var dataView = new DataView(dataset.dataView.buffer.slice(offset, offset + frameLen));
                    pixelDatas.push(dataView);
                }
            }
            return pixelDatas;
        }
    });
    return PixelData;
}());
export default PixelData;
